import gql from 'graphql-tag';

import { PhotoUrlTypeFields } from '../../../../apps/consumer/graphql/fragments/global';
import {
  PhotoForegroundDetails,
  PhotoWallpaperWatermarkDetails,
} from '../../../../graphql/fragments/photo';

const getAccountCardAlbumConfigurationPhotosQuery = gql`
  query getAccountCardAlbumConfigurationPhotos(
    $limit: Int = 40
    $photosOffset: Int = 0
    $favoritesOffset: Int = 0
    $album_id: RecordID!
  ) {
    album(id: $album_id) {
      id
      photos(
        slice: { limit: $limit, offset: $photosOffset }
        include_unprocessed: false
        for_web_gallery: true
        use_all_photos_mode: true
      ) {
        total
        count
        records {
          id
          thumbnail_urls(ignore_watermark: true) {
            ...PhotoUrlTypeFields
          }
          watermarked_urls {
            ...PhotoUrlTypeFields
          }
          faceblocked_thumbnail_urls {
            url
            size_code
            width
            height
            blur_type
            regions
          }
          ...PhotoWallpaperWatermarkDetails
          share_blocked
          is_entitled_matched_photo
          is_owner
          ...PhotoForegroundDetails
        }
      }
      favorited_photos(slice: { limit: $limit, offset: $favoritesOffset }) {
        total
        records {
          id
          photo {
            thumbnail_urls(ignore_watermark: true) {
              ...PhotoUrlTypeFields
            }
          }
        }
      }
    }
  }
  ${PhotoUrlTypeFields}
  ${PhotoForegroundDetails}
  ${PhotoWallpaperWatermarkDetails}
`;

export default getAccountCardAlbumConfigurationPhotosQuery;
